import { render, staticRenderFns } from "./OrderDetailAddi.vue?vue&type=template&id=2459c7f6&"
import script from "./OrderDetailAddi.vue?vue&type=script&lang=js&"
export * from "./OrderDetailAddi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports